<template>
  <div class="left_top">
    <div class="left_top__info">
      <div v-if="leftTopInfo.liveStatus === 2" class="left_top__live_icon">
        <div class="left_top__point"></div>
        <div class="left_top__status">LIVE</div>
      </div>
      <div v-else-if="leftTopInfo.liveStatus === 1">
        <span class="left_top__status">UPCOMING</span>
      </div>
      <div v-else-if="leftTopInfo.liveStatus === 4">
        <span class="left_top__status">REPLAY</span>
      </div>

      <div class="left_top__location">
        <div class="left_top__location_info">
          {{ `${leftTopInfo.city},${leftTopInfo.country}` }}
        </div>
      </div>
    </div>
    <div class="left_bottom">
      <img
        class="left_bottom__avatar global_pointer"
        :src="leftTopInfo.avatar"
        @click="goHostDetail()"
      />
      <!-- <div class="left_bottom__owner" @click="goHostDetail()"> -->
        <div class="left_bottom__nickname" @click="goHostDetail()">{{ leftTopInfo.nickname }}</div>
      <!-- </div> -->
      <div
        @click.stop="follow"
        v-if="!leftTopInfo.isFollowed"
        class="global_pointer left_bottom__follow left_bottom__follow-dis"
      >
        Follow
      </div>
      <div v-else class="left_bottom__follow left_bottom__follow-done"></div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api_list.js";
export default {
  props: {
    leftTopInfo: {
      type: Object,
      default: () => {
        return {
          country: "",
          city: "",
          avatar: "",
          nickname: "",
          isFollowed: 0,
          liveStatus: 0,
          hostId: null,
          //0无角色、1个人主播（社招主播）、2商家主播、3平台主播 ,
          role: 0,
          storeId: null,
        };
      },
    },
  },
  methods: {
    goHostDetail() {
      if (this.leftTopInfo.role == 2 && this.leftTopInfo.storeId) {
        this.$router.push({
          path: "/store",
          query: {
            storeId: this.leftTopInfo.storeId,
          },
        });
      } else if (
        this.leftTopInfo.hostId &&
        (this.leftTopInfo.role == 1 || this.leftTopInfo.role == 3)
      ) {
        this.$router.push({
          path: "/anchor",
          query: {
            hostId: this.leftTopInfo.hostId,
          },
        });
      }
    },
    async follow() {
      this.$isLogin(
        function () {
          api
            .live_add_host_like({
              hostId: this.leftTopInfo.hostId,
              liveId: this.leftTopInfo.liveId,
              source: "h5",
            })
            .then((res) => {
              if (res.code == 0) {
                this.leftTopInfo.isFollowed = true;
                // this.$toast(res.msgEn || 'succeeded')
              }
            });
        }.bind(this)
      );
    },
  },
};
</script>

<style lang="less" scoped>
.left_top{
  height: 40px;
  display: flex;
  padding-left: 12px;
  padding-right: 10px;
  flex-direction: column;
  &__info {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    color: #e3e3e3;
  }
  &__live_icon {
    display: flex;
    justify-content: left;
    align-items: center;
    // margin-right: 9px;
  }
  &__point {
    width: 8px;
    height: 8px;
    background: #FF0103;
    border-radius: 50%;
    margin-right: 8px;
  }
  &__location {
    height: 100%;
    display: flex;
    align-items: center;
    &_icon {
      width: 10px;
      height: 10px;
    }
    &_info {
      margin-left: 8px;
      font-size: 10px;
      font-weight: normal;
      color: #e3e3e3;
    }
  }

  &__status {
    font-size: 18px;
    font-weight: 1000;
    color: rgba(255, 255, 255, 0.9);
  }
}
.left_bottom {
  height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
  // padding-right: 10px;
  &__avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 4px;
  }
  &__owner {
    flex: 1;
    overflow: hidden;
  }
  &__nickname {
    // flex: 1;
    font-size: 12px;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  &__follow {
    height: 26px;
    line-height: 26px;
    text-align: center;
    border-radius: 18px;
    margin-left: 8px;
    &-dis {
      width: 65px;
      background: #F2FFD3;
      color: #0D0E13;
      font-size: 12px;
      // font-weight: bold;
      font-family: "Approach-Medium";
    }
    &-done {
      margin-left: 0px;
      width: 42px;
      // height: 42px;
      background: url("../../assets/imgs/room/follow.png") center center
        no-repeat;
      background-size: auto 26px;
    }
  }
  
  
}
</style>